import { People } from './components/People/PeopleStory'

export const team: Array<People> = [
  {
    photo: '/assets/team/konrad_hopek.jpg',
    description: 'LandingPage.Team.konrad_hopek.desc',
    name: 'Konrad Hopek',
    title: 'LandingPage.Team.konrad_hopek.title',
  },
  {
    photo: '/assets/team/ewa_kruk.jpg',
    description: 'LandingPage.Team.ewa_kruk.desc',
    name: 'Ewa Kruk',
    title: 'LandingPage.Team.ewa_kruk.title',
  },
  {
    photo: '/assets/team/wojtek.jpg',
    description: 'LandingPage.Team.wojtek.desc',
    name: 'Wojtek Jurojć',
    title: 'LandingPage.Team.wojtek.title',
  },
  {
    photo: '/assets/team/piotr_karwala.jpg',
    description: 'LandingPage.Team.piotr_karwala.desc',
    name: 'Piotr Karwala',
    title: 'LandingPage.Team.piotr_karwala.title',
  },
]
